<app-header />
<main role="main">
  <router-outlet />
  <div class="feedback-button">
    <button mat-icon-button (click)="openSupport()">
      <mat-icon fontSet="mat-symbol-round-fill">sms</mat-icon>
    </button>
  </div>
</main>
<app-footer />
<app-bottom-navigation />
